'use client';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/ui/tooltip';
import {useTranslations} from 'next-intl';
import {usePathname, useSearchParams} from 'next/navigation';
import {useEffect, useState} from 'react';

export default function PostShare({title}: {title: string}) {
  const t = useTranslations('Utils');
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [shareBtns, setShareBtns] = useState<any[]>([]);

  // 複製連結
  const handleCopy = async (urlToCopy: string, index: number) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(urlToCopy);
      } else {
        const el = document.createElement('input');
        el.value = urlToCopy;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      }
    } catch (err) {
      console.error('Copy failed', err);
    }

    const key = 'btn_' + index;
    setOpenTooltip((prev) => ({...prev, [key]: true}));

    setTimeout(() => {
      setOpenTooltip((prev) => ({...prev, [key]: false}));
    }, 1500);
  };

  useEffect(() => {
    const url = new URL(window.location.origin + pathname);
    searchParams.forEach((value, key) => {
      if (key !== 'referrer') {
        url.searchParams.append(key, value);
      }
    });

    const encodedUrl = encodeURIComponent(url.href);
    const encodedTitle = encodeURIComponent(title);

    setShareBtns([
      {
        icon: (
          <img
            src="/img/utils/share/fb.png"
            className="w-[30px] h-[30px]"
            alt="FB"
          />
        ),
        url: `https://facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        text: 'Facebook'
      },
      {
        icon: (
          <img
            src="/img/utils/share/mail.png"
            className="w-[30px] h-[30px]"
            alt="Mail"
          />
        ),
        url: `mailto:?subject=${encodedTitle}&body=${encodedUrl}`,
        text: 'Email'
      },
      {
        icon: (
          <img
            src="/img/utils/share/linkedin.png"
            className="w-[30px] h-[30px]"
            alt="LinkedIn"
          />
        ),
        url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        text: 'LinkedIn'
      },
      {
        icon: (
          <img
            src="/img/utils/share/whatsapp.png"
            className="w-[30px] h-[30px]"
            alt="WA"
          />
        ),
        url: `https://wa.me/?text=${encodedTitle}%0A${encodedUrl}`,
        text: 'WhatsApp'
      },
      {
        icon: (
          <img
            src="/img/utils/share/share.png"
            className="w-[30px] h-[30px]"
            alt="Copy"
          />
        ),
        text: 'Copy Link',
        url: '#',
        tooltip: t('copied'),
        onClick: () => handleCopy(url.href, 4)
      }
    ]);
  }, []);

  const [openTooltip, setOpenTooltip] = useState<{[key: string]: boolean}>({});

  return (
    <TooltipProvider>
      <div className="flex items-center justify-start gap-1">
        {shareBtns.map((btn, index) => {
          if (btn.tooltip) {
            return (
              <Tooltip key={index} open={openTooltip['btn_' + index]}>
                <TooltipTrigger asChild>
                  <a
                    href={btn.url}
                    onClick={btn.onClick}
                    className="cursor-pointer"
                  >
                    <div title={btn.text}>{btn.icon}</div>
                  </a>
                </TooltipTrigger>
                <TooltipContent>{btn.tooltip}</TooltipContent>
              </Tooltip>
            );
          }

          return (
            <a
              key={index}
              href={btn.url}
              onClick={btn.onClick}
              className="cursor-pointer"
            >
              <div title={btn.text}>{btn.icon}</div>
            </a>
          );
        })}
      </div>
    </TooltipProvider>
  );
}
